import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {responseSelector, getMidnightDateOrEmpty} from '../utils/utils';
import {useAlerts} from '../ui/alert';
import {alertTypes} from '../utils/Alert';
import {log} from '../utils/logs';
import {FeriadoCreateView} from './FeriadoCreateView';
import {feriadoCreateDuck, feriadoCreateThunk} from './duck';
import moment from 'moment';

export const FeriadoCreate = ({history, token}) => {
  const dispatch = useDispatch();

  const feriadoCreate = useSelector(state => state.feriadoCreate);

  const [nombre, setNombre] = useState('');
  const [fecha, setFecha] = useState(moment().startOf('day').toDate());

  const {topAlert, submitAlert, setSubmitAlert} = useAlerts();

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(feriadoCreate);

    if (error) {
      setSubmitAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(feriadoCreateDuck.actions.clear());
    }

    if (data) {
      dispatch(feriadoCreateDuck.actions.clear());

      setSubmitAlert({
        text: 'Feriado creado correctamente',
        type: alertTypes.success,
        closable: false,
      });

      history.push(`/feriados`);
    }
  }, [feriadoCreate]);

  function submit() {
    const data = {
      userToken: token.raw,
      nombre,
      fecha: getMidnightDateOrEmpty(fecha),
    };

    dispatch(feriadoCreateThunk(data));
  }

  return (
    <FeriadoCreateView
      history={history}
      feriadoCreate={feriadoCreate}
      submit={submit}
      submitAlert={submitAlert}
      topAlert={topAlert}
      nombre={nombre}
      setNombre={setNombre}
      fecha={fecha}
      setFecha={setFecha}
    />
  );
};
